<template>
  <div class="all">
    <Head></Head>
    <div class="dingzhi_banner">
      <el-carousel :interval="5000" arrow="never" style="height: 400px">
        <el-carousel-item v-for="(item,key) in Custom.custom_photo" :key="key" style="height: 400px;text-align: center">
          <img :src="$store.state.Url+item.img" alt="" style="height: 400px;">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="dingzhi">
      <div class="dingzhi_title">
        <span>POINT</span>
        <span>企业定制中心</span>
      </div>
      <div class="dingzhi_remen">
        <div class="dingzhi_remen_button">
          近期热门定制
        </div>
        <div>
          <el-carousel :interval="5000" arrow="always" indicator-position="none" style="height: 320px">
            <el-carousel-item style="height: 320px" v-for="(item,key) in List" :key="key">
              <div class="dingzhi_for_shop">
                <div class="dingzhi_for_shopFor" v-for="(val,ikey) in item" :key="ikey" style="width: 238px" @click="$router.push({path:'/details',query:{id:val.goods_id,status:3}})">
                  <div class="dingzhi_for_shopFor_img">
                    <img :src="$store.state.Url+val.goods_img" alt="">
                  </div>
                  <div class="dingzhi_for_shopFor_text">
                    <div>
                      <p>{{val.goods_name}}</p>
                      <span>【热门】</span>
                    </div>
                  </div>
                  <div class="dingzhi_for_shopFor_price">
                    <p>
                      ￥{{val.goods_price}}元
                    </p>
                  </div>
                </div>
                <div class="clear"></div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="dingzhi_maodian">
        <ul>
          <li>
            {{nowDate}}
            {{nowWeek}}
          </li>
          <li>
            <span>企业定制中心</span>
          </li>
          <li v-for="(item,key) in Custom.class" :key="key" style="cursor: pointer" @click="anchorJump(item.id)">
            {{item.name}}
          </li>
        </ul>
      </div>
      <div class="dingzhi_louceng">
        <div class="dingzhi_for" v-for="(val,index) in Custom.floor_level" :key="index" :id="`ss${val.id}`">
          <div class="dingzhi_for_title">
            <span>{{index+1}}F</span>
            {{val.name}}
          </div>
          <div class="dingzhi_for_img">
            <div class="dingzhi_for_img1">
              <img :src="val.floor_ure_img?$store.state.Url+val.floor_ure_img:img" alt="">
              <div class="dingzhi_for_img1_pos">
                <p>定制企业</p>
                <button @click="$router.push({path:'/dingzhigengduo',query:{id:val.id}})">查看更多定制</button>
              </div>
            </div>
            <div class="dingzhi_for_img2">
              <img :src="val.floor_show_img?$store.state.Url+val.floor_show_img:img" alt="">
            </div>
            <div class="clear"></div>
          </div>
          <div class="dingzhi_for_shop">
            <div class="dingzhi_for_shopFor" v-for="(item,ikey) in val.goods" :key="ikey" @click="$router.push({path:'/details',query:{id:item.goods_id,status:3}})">
              <div class="dingzhi_for_shopFor_img">
                <img :src="$store.state.Url+item.goods_img" alt="">
              </div>
              <div class="dingzhi_for_shopFor_text">
                <div>
                  <p>{{item.goods_name}}</p>
                  <span>【定制】</span>
                </div>
              </div>
              <div class="dingzhi_for_shopFor_price">
                <p>
                  ￥{{item.goods_price}}元
                </p>
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
    </div>
    <Pagetail></Pagetail>
  </div>
</template>

<script>
  import Pagetail from '../assembly/Pagetail'
  import Head from '../assembly/Head'
  import {getCustom} from '../api/index'
  import img from '../assets/zanwu.png'

  export default {
    name: "dingzhi",
    components: {
      Pagetail, Head
    },
    mounted() {
      this.init()
      this.timer1 = setInterval(() => {
        this.setNowTimes()
      }, 1000)
    },
    data() {
      return {
        Custom: {},
        img: img,
        timer1: null,
        nowWeek: '',
        nowDate: '',
        nowTime: '',
        List: []
      }
    },
    methods: {
      init() {
        getCustom().then(res => {
          this.Custom = res
          //以下为热门定制
          var data = this.Custom.customization
          for(var i=0,len=data.length;i<len;i+=5){
            this.List.push(data.slice(i,i+5));
          }
        })
      },
      anchorJump(id) {
        document.querySelector("#ss" + id).scrollIntoView(true);
      },
      setNowTimes() {
        let myDate = new Date()
        // console.log(myDate)
        let wk = myDate.getDay()
        let yy = String(myDate.getFullYear())
        let mm = myDate.getMonth() + 1
        let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate())
        let hou = String(myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours())
        let min = String(myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes())
        let sec = String(myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds())
        let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
        let week = weeks[wk]
        this.nowDate = yy + '-' + mm + '-' + dd
        this.nowTime = hou + ':' + min + ':' + sec
        this.nowWeek = week
      }
    },
  }
</script>

<style scoped lang="less">
  @import "css/dingzhi";

  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 400px;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/dingzhi.vue